import { motion } from "framer-motion";
import { DownloadFunctionality } from "../../components/downloadFunctionality";

const arrayHref = [
  {
    href: "https://play.google.com/store/apps/details?id=com.imadeabug.tapfast&pcampaignid=web_share",
    src: "/GooglePlayBadge.svg",
    alt: "GooglePlay",
  },
  {
    href: "https://apps.apple.com/pt/app/tap-fast/id6502991462?l=en-GB",
    src: "/AppStoreBadge.svg",
    alt: "AppStore",
  },
];

export const TapFastScreen = () => {
  return (
    <div
      id="tapfast-screen"
      className="flex flex-col sm:flex-row z-10 flex-1 gap-24 sm:gap-4 md:gap-4 lg:gap-24 justify-center"
    >
      {/* Left Part */}
      <div className="flex flex-col justify-center items-center gap-14 flex-1">
        <img
          src="/tap_fast_logo.png"
          alt="Logo"
          className="w-1/4 sm:w-2/5 md:w-1/2 lg:w-1/2 xl:w-3/4 flex align-center"
        />
      </div>
      {/* Phone */}
      <div className="flex-col justify-center items-center hidden sm:flex md:flex lg:flex flex-1">
        <motion.img
          src="/TapFast_Mobile.png"
          alt="Logo"
          className="sm:w-3/5 md:w-1/2 lg:w-1/2 xl:w-3/5"
          whileHover={{
            scale: 1.15, // Slight zoom-in
            rotate: [0, -5, 5, -3, 3, 0], // Subtle rotation effect
            rotateY: 15, // 3D tilt effect
            rotateX: 5, // Slight forward tilt
            transition: { duration: 0.6, ease: "easeInOut" },
          }}
          whileTap={{
            scale: 0.95, // Slight press-down effect when clicked
            rotateY: 0, // Resets tilt
            rotateX: 0,
            transition: { duration: 0.2 },
          }}
        />
      </div>
      {/* Download */}
      <div className="flex flex-col justify-center gap-12 items-center flex-1">
        <DownloadFunctionality arrayHref={arrayHref} />
      </div>
    </div>
  );
};
